import { Upload } from "lucide-react";
import { FC, RefObject } from "react";

interface UploadButtonProps {
    fileInputRef: RefObject<HTMLInputElement>;
    onFilesSelected: (files: FileList) => void;
    isUploading: boolean;
}

export const UploadButton: FC<UploadButtonProps> = ({
    fileInputRef,
    onFilesSelected,
    isUploading,
}) => {
    return (
        <div>
            <button
                onClick={() => fileInputRef.current?.click()}
                className="h-10 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600 flex items-center gap-2 whitespace-nowrap"
                disabled={isUploading}
            >
                <Upload className="w-5 h-5" />
                {isUploading ? "Uploading..." : "Upload Files"}
            </button>

            <input
                type="file"
                ref={fileInputRef}
                className="hidden"
                multiple
                accept="application/pdf"
                onChange={(e) => e.target.files && onFilesSelected(e.target.files)}
            />
        </div>
    );
};